{
  "PENDING": "Pending",
  "PROCESSING": "Processing",
  "PAID": "Paid",
  "COMPLETED": "Completed",
  "FAILED": "Failed",
  "SKIPPED": "Skipped",
  "RUNNING": "Running",
  "CANCELLED": "Cancelled",
  "SUCCESS": "Success",
  "FAILURE": "Failure"
}
